/* eslint-disable */
import { api } from './../../api.js';

const state = {
    title: null
};

const getters = {
    getSectionTitle : (state) => {
        return state.title;
    },
};

const mutations = {
    setSectionTitle : (state, title) => {
        state.title = title;
    },
};

const actions = {
    selectTypeUnits: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('type-units', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    setSectionTitle : function({ commit }, data){
        commit('setSectionTitle', data.title);
    },
    selectPrioritySamples: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('priorities/samples/select', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    selectProjectSamples: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('type-projects/samples/select', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    selectApplicationSamples: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('applications/samples/select', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getProjectSamples: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('type-projects/samples', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getApplicationSamples: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('applications/samples', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getPrioritiesSamples: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('priorities/samples', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getStatusOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('status/orders', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getStatusSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('status/samples', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createProjectSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('type-projects/samples', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createApplicationSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('applications/samples', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createStatusSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('status/samples', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createPrioritySampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('priorities/samples', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createStatusOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('status/orders', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editProjectSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('type-projects/samples/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editApplicationSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('applications/samples/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editStatusOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('status/orders/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editStatusSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('status/samples/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editPrioritySampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('priorities/samples/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteProjectSampleOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('type-projects/samples/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteApplicationSampleOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('applications/samples/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteStatusOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('status/orders/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteStatusSampleOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('status/samples/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deletePioritySampleOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('priorities/samples/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ConfigurationsModule.js